import { Button } from "antd";
import { getCompanyCardAutopay, getCompanyCardPaymentSystem, paymentSystem } from "../../extensions/helper";
import SberPayBtn from "../sberpay-btn.js/sberpay-btn";
import TcreditBtn from "../tcredit-btn/tcredit-btn";

/** Отобразить кнопки оплаты
 * @param {object} company компания
 * @param {boolean} isMobile признак что это мобильный дизайн
 * @param {func} onPay функция, вызваемая при нажатии
 * @param {boolean} disablePayment блокировка кнопок
 * @param {boolean} autopay услуга требует автоплатежа
 * @param {number} price стоимость услуги (для определения доступности кредита) 
 * @return {JSX.Element} компонент с кнопками
*/
const PayButtons = ({ company, isMobile, onPay, disablePayment, autopay, price, onBack }) => {
  return company && (isMobile ? <div className='buttons'>
    <div className='buttons-line1'>
      <Button className='catalog-item-pay-btn' type='default' size='middle' onClick={() => onPay(getCompanyCardPaymentSystem(company))} 
        disabled = {disablePayment || !getCompanyCardAutopay(company, autopay)}>Карта</Button>
      {company.payRaif && <Button className='catalog-item-pay-btn' type='default' size='middle' onClick={() => onPay(paymentSystem.Raif)} disabled = {disablePayment || autopay}>СБП</Button>}
    </div>
    <div className='buttons-line2'>
      {onBack && <Button className='catalog-item-pay-btn' type='default' size='middle' onClick={() => onBack()}>Назад</Button>}
      {company.paySberPay && <SberPayBtn onClick={() => onPay(paymentSystem.SberPay)} disabled = {disablePayment || autopay} />}
      {company.payCredit && <TcreditBtn onClick={() => onPay(paymentSystem.Credit)} disabled = {disablePayment || autopay || price < 3000} />}
    </div>
  </div> : <div className='buttons'> 
    <div className='buttons-line0'>
      <div />
      {onBack && <Button className='catalog-item-pay-btn' type='default' size='middle' onClick={() => onBack()}>Назад</Button>}
      <Button className='catalog-item-pay-btn' type='default' size='middle' onClick={() => onPay(getCompanyCardPaymentSystem(company))} 
        disabled = {disablePayment || !getCompanyCardAutopay(company, autopay)}>Карта</Button>
      {company.payRaif && <Button className='catalog-item-pay-btn' type='default' size='middle' onClick={() => onPay(paymentSystem.Raif)} disabled = {disablePayment || autopay}>СБП</Button>}
      {company.paySberPay && <SberPayBtn onClick={() => onPay(paymentSystem.SberPay)} disabled = {disablePayment || autopay}/>}
      {company.payCredit && <TcreditBtn onClick={() => onPay(paymentSystem.Credit)} disabled = {disablePayment || autopay || price < 3000} />}
    </div>
  </div>)
}

export default PayButtons;